import React from "react";
import {
  TextField,
  Stack,
  Typography,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

export const Secciones = ({ value, onChange }) => {
  const safeValue = {
    titulo: value?.titulo || "",
    secciones: Array.isArray(value?.secciones)
      ? value.secciones.map((sec) => ({
          titulo: sec?.titulo || "",
          notas: Array.isArray(sec?.notas)
            ? sec.notas
            : [],
        }))
      : [],
  };

  const isSeccionInvalida = (sec) => {
    return (
      !sec.titulo?.trim() ||
      !sec.notas.length ||
      sec.notas.some((n) => !n?.trim())
    );
  };

  const updateTituloGeneral = (titulo) => {
    onChange({
      ...safeValue,
      titulo,
    });
  };

  const updateTituloSeccion = (index, newTitulo) => {
    const copy = [...safeValue.secciones];
    copy[index].titulo = newTitulo;

    onChange({
      ...safeValue,
      secciones: copy,
    });
  };

  const updateNota = (secIndex, notaIndex, newNota) => {
    const copy = [...safeValue.secciones];
    copy[secIndex].notas[notaIndex] = newNota;

    onChange({
      ...safeValue,
      secciones: copy,
    });
  };

  const addSeccion = () => {
    onChange({
      ...safeValue,
      secciones: [
        ...safeValue.secciones,
        { titulo: "", notas: [] },
      ],
    });
  };

  const deleteSeccion = (index) => {
    const copy = [...safeValue.secciones];
    copy.splice(index, 1);

    onChange({
      ...safeValue,
      secciones: copy,
    });
  };

  const addNota = (secIndex) => {
    const copy = [...safeValue.secciones];
    copy[secIndex].notas.push("");

    onChange({
      ...safeValue,
      secciones: copy,
    });
  };

  const deleteNota = (secIndex, notaIndex) => {
    const copy = [...safeValue.secciones];
    copy[secIndex].notas.splice(notaIndex, 1);

    onChange({
      ...safeValue,
      secciones: copy,
    });
  };

  return (
    <Stack spacing={4} mt={4}>
      <TextField
        fullWidth
        label="Título (opcional)"
        value={safeValue.titulo}
        onChange={(e) =>
          updateTituloGeneral(e.target.value)
        }
      />

      {safeValue.secciones.map((sec, secIndex) => (
        <Box
          key={secIndex}
          sx={{
            border: "1px solid",
            borderColor: isSeccionInvalida(sec)
              ? "error.main"
              : "#e2e8f0",
            borderRadius: 2,
            p: 2,
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography fontWeight={600}>
              Sección {secIndex + 1}
            </Typography>

            <IconButton
              onClick={() => deleteSeccion(secIndex)}
            >
              <DeleteIcon />
            </IconButton>
          </Stack>

          <TextField
            fullWidth
            label="Título de sección"
            value={sec.titulo}
            error={!sec.titulo?.trim()}
            helperText={
              !sec.titulo?.trim() ? "El título es requerido" : ""
            }
            onChange={(e) =>
              updateTituloSeccion(secIndex, e.target.value)
            }
            sx={{ mt: 1 }}
          />

          <Stack spacing={2} mt={2}>
            {sec.notas.map((nota, notaIndex) => (
              <Stack
                direction="row"
                spacing={1}
                key={notaIndex}
              >
                <TextField
                  fullWidth
                  multiline
                  minRows={2}
                  label={`Nota ${notaIndex + 1}`}
                  value={nota}
                  error={!nota?.trim()}
                  helperText={
                    !nota?.trim() ? "La nota no puede estar vacía" : ""
                  }
                  onChange={(e) =>
                    updateNota(
                      secIndex,
                      notaIndex,
                      e.target.value
                    )
                  }
                />

                <IconButton
                  onClick={() =>
                    deleteNota(secIndex, notaIndex)
                  }
                >
                  <DeleteIcon />
                </IconButton>
              </Stack>
            ))}
          </Stack>

          <Button
            startIcon={<AddIcon />}
            sx={{ mt: 2 }}
            onClick={() => addNota(secIndex)}
          >
            Agregar nota
          </Button>
        </Box>
      ))}

      <Button
        startIcon={<AddIcon />}
        variant="contained"
        onClick={addSeccion}
      >
        Agregar sección
      </Button>
    </Stack>
  );
};
